<template>
  <div class="employee">
    <CCard class="card-table-emloyee">
      <CRow>
        <CCol sm="3">
          <div class="form-group">
            <label>{{
              $t("summer_trip.label_category")
            }}</label>
            <select
              class="form-control"
              v-model="categoryFilter"
              @change="filterCategory"
            >
              <option value="0">
                {{ $t("placeholder.label_employee_option_search") }}
              </option>
              <option v-for="(item, index) in dataMaster" :key="item.key + index" :value="index">{{index}}</option>
            </select>
          </div>
        </CCol>
      </CRow>
      <CRow>
        <CCol sm="12" class="text-center btn-search">
          <CButton class="btn-search-employee">{{
            $t("button.label_employee_btn_search")
          }}</CButton>
          <CButton class="btn-reset">{{
            $t("button.label_action_reset")
          }}</CButton>
        </CCol>
      </CRow>
    </CCard>
    <CRow>
      <CCol sm="12">
        <CCard class="employee-table">
          <CCardBody class="no-padding">
            <div class="table-responsive">
              <table class="table table-mobile">
                <thead>
                  <tr>
                    <th scope="col" class="cl-pointer">
                      {{ $t("summer_trip.label_summer_trip_info_code") }}
                    </th>
                    <th scope="col" class="cl-pointer">
                      {{ $t("summer_trip.label_summer_trip_info_name") }}
                    </th>
                    <th scope="col" class="cl-pointer">
                      {{ $t("summer_trip.label_summer_trip_info_type") }}
                    </th>
                    <th scope="col" class="cl-pointer">
                      {{ $t("summer_trip.label_summer_trip_info_color") }}
                    </th>
                    <th scope="col">
                      {{ $t("summer_trip.label_summer_trip_info_color_code") }}
                    </th>
                     <th scope="col">
                      {{ $t("summer_trip.label_summer_trip_info_action") }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                <template v-for="item in categories">
                  <tr  v-for="cate in item" :key="cate.key">
                    <td>{{ cate.code }}</td>
                    <td>{{ cate.name }}</td>
                    <td>{{ cate.type }}</td>
                    <td>{{ cate.color }}</td>
                    <td>{{ cate.color_type}}</td>
                    <td>
                      <div class="btn btn-primary btn-sm" @click="showModal(cate.id)">
                          {{ $t("button.label_action_edit") }}
                      </div>
                    </td>
                  </tr>
                </template>
                </tbody>
              </table>
            </div>
          </CCardBody>
        </CCard>
      </CCol>
    <b-modal ref="detailModal"  id="modal-lg" size="lg" hide-footer v-b-modal="" :title="getTitleModal()">
        <ValidationObserver v-slot="{ handleSubmit }">
          <CForm  @submit.prevent="handleSubmit(updateCategory)">
            <template>
              <h5></h5>
              <template>
                <CCard>
                  <CCardHeader>
                    <div class="d-flex flex-row flex-between">
                      <div class="text-bold category-key">{{$t('summer_trip.label_summer_trip_info_key')}}</div>
                      <div class="text-bold">{{$t('summer_trip.label_summer_trip_info_value')}}</div>
                      <div class="text-bold">{{$t('summer_trip.label_summer_trip_info_action')}}</div>
                    </div>
                  </CCardHeader>
                  <CCardBody>
                      <div class="d-flex flex-row flex-between">
                        <div class="category-key mt-2">
                          <label>
                            {{$t('summer_trip.label_summer_trip_info_code')}}
                            <span class="require">*</span>
                          </label>
                        </div>
                        <ValidationProvider
                          rules="required"
                          v-slot="{ errors }"
                          :name="$t('summer_trip.label_summer_trip_info_code')"
                          class="w-65"
                        >
                          <input type="text" class="form-control" v-model="categoryDetail.code">
                          <span class="required">{{ errors[0] }}</span>
                        </ValidationProvider>
                        <div></div>
                      </div>
                  </CCardBody>
                  <CCardBody>
                      <div class="d-flex flex-row flex-between">
                        <div class="category-key mt-2">
                        <label>
                            {{$t('summer_trip.label_summer_trip_info_name')}}
                            <span class="require">*</span>
                          </label>
                        </div>
                        <ValidationProvider
                          rules="required"
                          v-slot="{ errors }"
                          :name="$t('summer_trip.label_summer_trip_info_name')"
                          class="w-65"
                        >
                          <input type="text" class="form-control" v-model="categoryDetail.name">
                          <span class="required">{{ errors[0] }}</span>
                        </ValidationProvider>
                        <div></div>
                      </div>
                  </CCardBody>
                  <CCardBody>
                      <div class="d-flex flex-row flex-between">
                        <div class="category-key mt-2">
                        <label>
                            {{$t('summer_trip.label_summer_trip_info_type')}}
                            <span class="require">*</span>
                          </label>
                        </div>
                        <ValidationProvider
                          rules="required"
                          v-slot="{ errors }"
                          :name="$t('summer_trip.label_summer_trip_info_type')"
                          class="w-65"
                        >
                          <input type="text" class="form-control" v-model="categoryDetail.type" disabled>
                          <span class="required">{{ errors[0] }}</span>
                        </ValidationProvider>
                        <div></div>
                      </div>
                  </CCardBody>
                  <CCardBody>
                      <div class="d-flex flex-row flex-between">
                        <div class="category-key mt-2">
                        <label>
                            {{$t('summer_trip.label_summer_trip_info_color')}}
                          </label>
                        </div>
                          <input type="text" class="form-control w-65" v-model="categoryDetail.color">
                        <div></div>
                      </div>
                  </CCardBody>
                  <CCardBody>
                      <div class="d-flex flex-row flex-between">
                        <div class="category-key mt-2">
                        <label>
                            {{$t('summer_trip.label_summer_trip_info_color_code')}}
                          </label>
                        </div>
                          <input type="text" class="form-control w-65" v-model="categoryDetail.color_code">
                        <div></div>
                      </div>
                  </CCardBody>
                  <template v-if="!(categoryDetail.type == 'FLIGHT')">
                    <CCardBody v-for="(item) in categoryMetaData" :key="item.id">
                      <div class="d-flex flex-row flex-between">
                        <input type="text" class="form-control category-key-input" v-model="item.key" :title="item.key">
                        <input type="text" class="form-control w-65" v-model="item.value" :title="item.value">
                        <div class="btn btn-danger btn-sm align-self-center" @click="deleteCategory(item.id)">-</div>
                      </div>
                    </CCardBody>
                  </template>
                </CCard>
                <template v-if="(categoryDetail.type == 'FLIGHT')">
                    <CCard v-for="(item, key) in flightMetaData" :key="item.key">
                      <h5 class="m-3">{{$t('summer_trip.label_summer_trip_flight')}} {{key + 1}}</h5>
                        <CCardBody v-for="(i, k) in item" :key="i.k">
                          <div class="d-flex flex-row flex-between">
                            <div class="category-key-input align-self-center">
                            <label>{{k}}</label>
                              </div>
                                <input type="text" class="form-control w-65" v-model="item[k]">
                            </div>
                        </CCardBody>
                    </CCard>
                </template>

                <div class="w-100 text-center" v-if="categoryDetail.type != 'FLIGHT'">
                  <div class="btn btn-primary btn-sm align-self-center w-25 " @click="addCategory()">+</div>
                </div>
                <div class="d-flex flex-row mt-3 justify-content-end">
                  <b-button variant="outline-danger w-30 mr-2"  @click="hideModal">{{$t("button.label_action_cancel")}}</b-button>
                  <b-button variant="outline-warning w-30"  type="submit">{{$t("button.label_action_update")}}</b-button>
                </div>
              </template>
            </template>
          </CForm>
        </ValidationObserver>
    </b-modal>
    </CRow>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
// import moment from 'moment';
// import { number } from 'echarts/core';
import { ValidationProvider, ValidationObserver } from "vee-validate";

export default {
  name: "CustomerIndex",
  metaInfo() {
    return {
      title: this.$t("summer_trip.label_title_page"),
      titleTemplate: "%s | " + this.$t("page_title.head_title")
    };
  },
  components: {
    ValidationObserver,
    ValidationProvider
  },
  data() {
    return {
      categoryFilter: 0,
      categories: [],
      categoryDetail: {},
      categoryMetaData: [],
      keyLabel: "Key",
      valueLabel: "Value",
      flightMetaData: []
    };
  },
  computed: {
    ...mapGetters({
      companies: "commons/companies",
      divisions: "commons/divisions",
      flights: "summer-trip/flights",
      team_groups: "summer-trip/team_groups",
      car_groups: "summer-trip/car_groups",
      flight_groups: "summer-trip/flight_groups",
      dataMaster: "summer-trip/dataMaster",
      category: "summer-trip/category"
    })
  },
  methods: {
    ...mapActions("summer-trip", ["fetchSummerTripTeams", "getSummerTripMasterDetail", "updateSummerTripMaster"]),
    ...mapActions("layout", ["setLoading"]),

    async fetchData(){
      await this.fetchSummerTripTeams();
      this.categories = this.dataMaster;
    },
    filterCategory(){
      if(this.categoryFilter == 0){
        this.categories = this.dataMaster
        return;
      }
      const scoreArr = Object.entries(this.dataMaster);
      const type = this.categoryFilter;
      const categoriesArr = scoreArr.filter( function ([key]) {
          return key == type
      });
      this.categories = Object.fromEntries(categoriesArr);

    },
    async showModal(id) {
      this.clearModal();
      await this.getSummerTripMasterDetail(id)
            .then(() => {
              this.categoryDetail = this.category
              var id = 0;
              if(this.category.info){
                if((this.categoryDetail.type == 'FLIGHT')){
                  this.flightMetaData = this.category.info;
                }else{
                  for (const [key, value] of Object.entries(this.category.info)) {
                    this.categoryMetaData.push({id, key,value});
                    id++;
                  }
                }
              }
            })
             .catch((error) => {
              console.error("The Promise is rejected!", error);
            })
            .finally(() => {

            });
      this.$refs["detailModal"].show();
    },
    getTitleModal(){
      return this.$t('summer_trip.label_summer_trip_detail');
    },
    hideModal() {
      this.$refs["detailModal"].hide();
    },
    async updateCategory() {
      this.setLoading(true);
      var meta = {};
      if(this.categoryDetail.type == 'FLIGHT'){
        this.categoryDetail.info = JSON.stringify(this.flightMetaData);
      }else{
        this.categoryMetaData.forEach((element) => {
          var key = element.key;
          var value = element.value;
          var obj = {};
          obj[key] = value;
          meta = {...meta, ...obj};
        });
        this.categoryDetail.info = JSON.stringify(meta);
      }
      await this.updateSummerTripMaster(this.categoryDetail)
            .then(() => {
              let message = this.$t("summer_trip.popup.update_category_success");
              this.$toast(message, null, 2000, "b-toaster-top-center", "success");
              this.setLoading(false);
            })
            .catch((e) => {
              console.error(e);
              this.setLoading(false);
            });
      await this.fetchData()
      this.$refs["detailModal"].hide();
    },
    clearModal(){
      this.categoryMetaData = [];
      this.flightMetaData = [];
    },
    deleteCategory(id){
      this.categoryMetaData = this.categoryMetaData.filter((e) => {
        return e.id != id;
      })
    },
    addCategory(){
      const id = this.categoryMetaData.length;
      const key = "";
      const value = "";
      this.categoryMetaData.push({id, key,value});
    }

  },
  created() {
    this.fetchData()
  },
};
</script>

<style lang="scss" scoped>
.employee {
  margin: -2rem -30px 0 -30px;
  .card-table-emloyee {
    padding: 30px;
  }
  .btn-search-employee {
    background-color: #b5dbf2;
    padding: 8px;
    width: 120px;
  }
  .employee-table {
    margin: 24px 27px 0 30px;
  }
  .total-employee {
    background-color: #FFFFFF;
    margin: 0 27px 0 30px;
    border-radius: 5px;
    padding: 10px 20px;
    p {
      margin: 0;
      &:first-child {
        margin-bottom: 5px;
      }
      &>span {
        font-weight: bold;
      }
    }
  }
  .select-per-page {
    width: 70px;
  }
.guest-name {
  padding-left: 55px;
}
.no-padding {
  padding: 0px !important;
  & thead > tr > th {
    border-top: none;
  }
}
.margin-left-4 {
  margin-left: 4px;
}
.help {
  cursor: pointer;
}
.guest_row {
  background: #EFF2F7;
}
.text-center {
  text-align: center;
}
.card-summary {
  text-align: center;
}
.text-summary-member {
  font-size: 70px;
  font-weight: bold;
  color: #3488EB;
  &.primary {
    color: #FF5253;
  }
}

.text-summary-label {
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  }
  .option-table {
    display: flex;
    justify-content: space-between;
  }
}
.d-flex {
  display: flex;
}
.flex-row {
  flex-direction: row;
}
.flex-between {
  justify-content: space-between;
}
.text-bold {
  font-weight: 700;
}
.card-body:last-child{
  border: none;
}
.card-body {
  border-bottom: 1px solid #b0b0b0;
}
@media screen and (max-width: 767px) {
  .card-body {
    padding: 0 0.5rem;
  }
  .table-mobile {
    width: 900px;
    overflow-x: scroll;
  }
}
.cl-pointer {
  cursor: pointer;
  .icon-sort {
    margin-left: 5px;
    .c-icon {
      width: 12px;
    }
    .sort-rotate {
      transform: rotate(180deg);
    }
  }
}
.category-key {
  width: 102px;
}
.category-key-input {
  width: 130px;
}
.require {
  color: red;
}
.required {
  color: red;
  // margin-left: 156px;
}
.w-65 {
  width: 65%;
}
label {
  margin-bottom: 0;
}
</style>
